

















































































































































































































import {
  Component,
  Mixins,
} from 'vue-property-decorator';
import SapData from '@/components/Pretensions/SapData.vue';
import { Pretension, PretensionStatus } from '@/types/Pretension';
import PretensionController from '@/controllers/Pretension';
import DocumentsMixin from '@/mixins/Documents';
import UserMixin from '@/mixins/UserMixin';
import ValidationErrorMixin from '@/mixins/ValidationErrorMixin';
import { required } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';

@Component({
  components: {
    SapData,
  },
})
export default class PretensionPage extends Mixins(DocumentsMixin, UserMixin, validationMixin, ValidationErrorMixin) {
  private pretension: Pretension = {
    id: 0,
    sequence: '',
    type: '',
    dateFrom: '',
    dateTo: '',
    postDate: '',
    platfromName: '',
    supplierLegalName: '',
    status: PretensionStatus.CREATED,
    clients: [],
    documents: [],
  }

  headers = [
    {
      text: 'Клиент',
      value: 'clientName',
    },
    {
      text: 'Центр затрат',
      value: 'costCenterName',
    },
    {
      text: 'Сумма',
      value: 'sum',
    },
  ]

  private isLoadingPretension = false;

  private isSendingApprovingRequest = false;

  private isSendingCancellingRequest = false;

  private isVisibleCancelDialog = false;

  private isVisibleCredentialsDialog = false;

  private showPassword = false;

  private diadocCredentials = {
    login: '',
    password: '',
  }

  @Validations()
  validations() {
    return {
      diadocCredentials: {
        login: {
          required,
        },
        password: {
          required,
        },
      },
    };
  }

  created() {
    this.loadPretension(this.pretensionId);
  }

  private get isAccountantApproveAction(): boolean {
    return this.pretension.status === PretensionStatus.ACCOUNTING_APPROVE_AWAIT && this.isAccountant;
  }

  private get isPaymentDoneAction(): boolean {
    return this.pretension.status === PretensionStatus.PAYMENT_AWAIT && this.isAccountant;
  }

  private get isSignerApproveAction(): boolean {
    return this.pretension.status === PretensionStatus.SIGNER_SIGNING_AWAIT && this.isSigner;
  }

  get pretensionId(): number {
    return Number(this.$route.params.id);
  }

  get cancelAllowed(): boolean {
    return (this.isSigner && this.pretension.status === PretensionStatus.SIGNER_SIGNING_AWAIT)
      || (this.isHR && (this.pretension.status === PretensionStatus.SUPPLIER_SIGNING_AWAIT || this.pretension.status === PretensionStatus.SIGNER_SIGNING_AWAIT))
      || (this.isAccountant && this.pretension.status === PretensionStatus.ACCOUNTING_APPROVE_AWAIT);
  }

  get approveAllowed(): boolean {
    return (this.isSigner && this.pretension.status === PretensionStatus.SIGNER_SIGNING_AWAIT)
      || (this.isHR && this.pretension.status === PretensionStatus.SUPPLIER_SIGNING_AWAIT)
      || (this.isAccountant && this.pretension.status === PretensionStatus.ACCOUNTING_APPROVE_AWAIT)
      || ((this.isAccountant || this.isHR) && this.pretension.status === PretensionStatus.PAYMENT_AWAIT);
  }

  get buttonName(): string {
    if (this.isSignerApproveAction) {
      return 'Подписать';
    }
    if (this.isAccountantApproveAction) {
      return 'Отправить в SAP';
    }
    if (this.isPaymentDoneAction) {
      return 'Оплачено';
    }
    return 'Отправить дальше';
  }

  get isAvailableButton(): boolean {
    return this.isAccountantApproveAction || this.isPaymentDoneAction || this.isSignerApproveAction;
  }

  public getDocumentType(type: string): string {
    const map = new Map([
      ['pretension', 'Претензия'],
      ['attachment', 'Приложение'],
      ['default', 'Приложение'],
    ]);
    const name = map.get(type) !== undefined ? map.get(type) : map.get('default');
    return name || '';
  }

  async loadPretension(id: number): Promise<void> {
    if (!id) {
      return;
    }
    this.isLoadingPretension = true;
    try {
      const response = await PretensionController.single(id);
      const [error, result] = response.result;
      if (error) {
        this.$bus.$emit('notification', 'Возникла ошибка при получении претензии, попробуйте позже', 'error');
        console.error(error);
        return;
      }
      if (result.result) {
        this.pretension = result.result;
        this.makeDocumentsLinks(result.result);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.isLoadingPretension = false;
    }
  }

  onSubmit(): void {
    if (this.isSignerApproveAction) {
      this.isVisibleCredentialsDialog = true;
    } else if (this.isAccountantApproveAction) {
      this.approveByAccountant();
    } else if (this.isPaymentDoneAction) {
      this.sendPaymentDone();
    } else {
      this.$bus.$emit('notification', 'Невозможно сопоставить статус претензии и роль пользователя для определения действия', 'warning');
    }
  }

  onError(error: any): void {
    this.$bus.$emit('notification', `Возникла ошибка при выполнении операции, попробуйте позже - ${error}`, 'error');
    console.error(error);
  }

  onSuccess(result: any): void {
    console.log('Result after request - ', result);
    this.$bus.$emit('notification', 'Операция успешно выполнена', 'success');
    this.loadPretension(this.pretensionId);
  }

  async approveBySigner(): Promise<void> {
    try {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isSendingApprovingRequest = true;
      const userEmail = this.pimcoreUser.email;
      const [error, result] = (await PretensionController.approveBySigner(
        this.pretensionId,
        userEmail,
        this.diadocCredentials.login,
        this.diadocCredentials.password,
      )).result;
      if (error) {
        this.onError(error);
      } else {
        this.onSuccess(result);
        this.isVisibleCredentialsDialog = false;
      }
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async approveByAccountant(): Promise<void> {
    try {
      (this.$refs.sapData as any).$v.$touch();
      if ((this.$refs.sapData as any).$v.$invalid) {
        this.$bus.$emit('notification', 'Пожалуйста, заполните данные для SAP', 'warning');
        return;
      }

      this.isSendingApprovingRequest = true;
      const isUpdatedSapData: boolean = await (this.$refs.sapData as any).onSubmit(true);
      if (!isUpdatedSapData) return;

      const [error, result] = (await PretensionController.approveByAccountant(this.pretensionId)).result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async sendPaymentDone(): Promise<void> {
    try {
      this.isSendingApprovingRequest = true;
      const [error, result] = (await PretensionController.paymentDone(this.pretensionId)).result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async cancelPretension(): Promise<void> {
    try {
      if (!this.cancelAllowed) {
        throw new Error('Статус претензии не позволяет ее отменить');
      }
      if (this.pretension.id === 0) {
        this.loadPretension(this.pretensionId);
        throw new Error('Претензия не загружена, попробуйте позже');
      }

      this.isSendingCancellingRequest = true;
      this.isVisibleCancelDialog = false;

      const [error, result] = (await PretensionController.cancel(this.pretensionId)).result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingCancellingRequest = false;
    }
  }
}
